import React from 'react';
import Icon from '../AppIcon';

const ValidationFeedback = ({ 
  type = 'error',
  message,
  messages = [],
  className = '' 
}) => {
  const messagesToDisplay = message ? [message] : messages;

  if (!messagesToDisplay || messagesToDisplay?.length === 0) {
    return null;
  }

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'CheckCircle2';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
      default:
        return 'AlertCircle';
    }
  };

  return (
    <div className={`space-y-2 ${className}`}>
      {messagesToDisplay?.map((msg, index) => (
        <div key={index} className={`validation-message ${type}`}>
          <Icon 
            name={getIcon()} 
            size={16} 
            className="validation-icon" 
          />
          <span className="flex-1">{msg}</span>
        </div>
      ))}
    </div>
  );
};

export default ValidationFeedback;